export function getPaginationSummary({ total, limit, currentPage }) {
    // Calculate the starting and ending item indices
    const start = total > 0 ? (currentPage - 1) * limit + 1 : 0;
    const end = Math.min(currentPage * limit, total);

    // Return the summary string
    return `${start}-${end} dari ${total}`;
}

export function hasNextPage({ total, limit, currentPage }) {
    if (total > currentPage * limit) {
        return true;
    } else {
        return false;
    }
}
